// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"2023fb6b","225":"2023fb6b"}[chunkId] + ".chunk.css";
};